import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Navbar from "./components/Navbar";
import VehiclePage from "./pages/VehiclePage";
import Login from "./pages/login";
import Register from "./pages/register";
import ProtectedRoute from "./components/ProtectedRoute";
import axios from "axios";

import AddVehicle from "./pages/AddVehicle";

import ProfilePage from "./pages/ProfilePage";

import BookingPage from "./pages/BookingPage";
import HomePage from "./pages/HomePage";
import Loader from "./components/Loader"; // Your loading component
import VehicleOwnerPage from "./pages/VehicleOwnerPage";
import Admin from "./pages/Admin";

function App() {
  axios.defaults.withCredentials = true;
  const [loading, setLoading] = useState(false);

  return (
    <BrowserRouter>
      {loading && <Loader />} {/* Show loading overlay */}
      <Routes>
        {/* Home Page without Navbar */}
        
        <Route path="/" element={<HomePage setLoading={setLoading} />} />

        <Route path="/signIn" exact element={<Login/>} />
        <Route path="/signUp" exact element={<Register/>} />

        <Route element={<ProtectedRoute />}>
          <Route path="/admin" exact element={<Admin />} />
        </Route>
        
        
        {/* All Other Pages with Navbar */}
        <Route
          path="/*"
          element={
            <div className="App bg-white">
              {!loading && <Navbar />} {/* Hide Navbar while loading */}
              <Routes>
                
                <Route
                  path="/vehicles"
                  element={
                    <VehiclePage setLoading={setLoading} loading={loading} />
                  }
                />
                  <Route
                    path="/book/:vehicleId"
                    element={
                      <BookingPage setLoading={setLoading} loading={loading} />
                    }
                  />
                <Route element = {<ProtectedRoute />}>
                  
                  <Route path="/addVehicle" exact element={<AddVehicle setLoading={setLoading} loading={loading}/>} />

                  <Route
                    path="/view/:vehicleId"
                    element={
                      <VehicleOwnerPage setLoading={setLoading} loading={loading} />
                    }
                  />

                  <Route
                    path="/profile"
                    element={
                      <ProfilePage setLoading={setLoading} loading={loading} />
                    }
                  />
                </Route>


                

              </Routes>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
